import * as Yup from 'yup';

const passwordRegex = new RegExp(
  /^(?=(?:[^A-Za-z]*[A-Za-z]){1})(?=(?:[^0-9!@#$%^&*()_+-=]*[0-9!@#$%^&*()_+-=]){1}).*$/
);
const passwordErrorMessage =
  'Password must be a minimum of 8 characters, contain a letter AND a number OR special character.';
const phoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
const phoneNumberErrorMessage = 'Must be a valid phone number';

const dateOfBirthRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
const incomeRegex = /([1-9][0-9]{2,}|[4-9][0-9]|4[0-9])[0-9]{2}$/;
const ssnRegex = /^(X{9}|\d{9})$/;

export const emailSchema = Yup.string()
  .email('Please enter a valid email address')
  .required('Email address is required');

export const loginPasswordSchema = Yup.string().required(
  'Password is required'
);

export const createAccountPasswordSchema = Yup.string()
  .required('Password is required')
  .min(8, passwordErrorMessage)
  .matches(passwordRegex, passwordErrorMessage);

export const confirmPasswordSchema = passwordRef =>
  Yup.string()
    .required('Passwords must match')
    .oneOf([Yup.ref(passwordRef), null], 'Passwords must match');

export const firstNameSchema = Yup.string()
  .required('First name is required')
  .min(2, 'First name must be between 2 and 30 characters long');

export const lastNameSchema = Yup.string()
  .required('Last name is required')
  .min(2, 'Last name must be between 2 and 30 characters long');

export const zip5Schema = Yup.string()
  .required('Zip code is required')
  .min(5, 'Please enter a valid zip code')
  .max(5, 'Must be no more than 5 numbers');

export const phoneNumberSchema = Yup.string()
  .required('Phone number is required')
  .matches(phoneNumberRegex, phoneNumberErrorMessage);

export const dateOfBirthSchema = Yup.string()
  .required('Date of Birth is Required')
  .matches(dateOfBirthRegex, 'Must be a Valid Date of Birth');

export const incomeSchema = Yup.string()
  .required('Income is Required')
  .matches(incomeRegex, 'Income must be at or above $4,000');

export const ssnSchema = Yup.string()
  .required('Social Security Number is Required')
  .matches(ssnRegex, 'Must be a Valid Social Security Number');
